import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VisitObjective } from '../../../models/lookups/visitObjective.model';
import { VisitObjectiveService } from '../visit-objective.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DisplayModes } from '../../../models/enums';
import { ItemFormat } from '../../../models/lookups/itemFormat.model';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { AppTranslationService } from '../../../services/app-translation.service';

@Component({
  selector: 'crm-add-visit-objective',
  templateUrl: './add-visit-objective.component.html',
  styleUrls: ['./add-visit-objective.component.css']
})
export class AddVisitObjectiveComponent implements OnInit {

  displayMode: DisplayModes = DisplayModes.Success;
  visitObjective: VisitObjective = new VisitObjective();

  @Output() closeEvent = new EventEmitter<boolean>();
  @Input() visitObjectiveId: number;
  constructor(private readonly visitObjectiveService: VisitObjectiveService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly translateService: AppTranslationService,
    private readonly alertService: AlertService) { }

  ngOnInit() {
    if (this.visitObjectiveId != undefined)
      this.getVisitObjective(this.visitObjectiveId);
  }

  getVisitObjective(visitObjectiveId) {
    this.displayMode = DisplayModes.Loading;
    this.visitObjectiveService.getById(visitObjectiveId).subscribe(responce => {
      this.displayMode = DisplayModes.Success;
      this.visitObjective = responce as VisitObjective;
    },
      err => {
        this.displayMode = DisplayModes.Error;
        console.log('error in get item fromat');
        console.log(err);
      });
  }

  save(form) {
    if (!form.invalid) {

      this.displayMode = DisplayModes.Loading;

      this.alertService.startLoadingMessage("", this.translateService.getTranslation("Saving"));
      this.visitObjectiveService.save(this.visitObjective).subscribe(() => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Success;
        this.back();
        this.alertService.showMessage("", this.translateService.getTranslation("clm.savedSuccessfully"), MessageSeverity.Success);
      }, () => {
        this.alertService.stopLoadingMessage();
        this.displayMode = DisplayModes.Error;
      });
    }
  }

  back() {
    this.closeEvent.emit(true);
  }

}
